import postingGroup from "./general-posting-group";
import vatPostingGroup from "./vat-posting-group";
import postingSetup from "./posting-setup";
import generalLedger from "./general-ledger";
import generalConfiguration from "./general-configuration";

const baseUrl = "/master-data";

export default [
    {
        icon: "mdi-database",
        key: "title.generalPostingGroup",
        link: baseUrl + "/general-posting-group",
        items: postingGroup,
        level:2,
        keywords: "posting group",
      },
      {
        icon: "mdi-database",
        key: "title.vatPostingGroup",
        link: baseUrl + "/vat-posting-group",
        items: vatPostingGroup,
        level:2,
        keywords: "vat posting group",
      },
      {
        icon: "mdi-database",
        key: "title.postingSetup",
        link: baseUrl + "/posting-setup",
        items: postingSetup,
        level:2,
        keywords: "posting setup",
      },
      {
        icon: "mdi-database",
        key: "title.generalLedger",
        link: baseUrl + "/general-ledger",
        items: generalLedger,
        level:2,
        expanded: true,
        keywords: "general ledger",
      },
      {
        icon: "mdi-database",
        key: "title.generalConfiguration",
        link: baseUrl + "/general-configuration",
        items: generalConfiguration,
        level:2,
        keywords: "general configuration",
      }
];
